export default __webpack_public_path__ + "static/media/esgSentiment.aa4c6152.png";